import axios from "axios";
import common from "./common.js";
import global from "./global.js";

const service = axios.create({
    // baseURL: process.env.BASE_API, // api的base_url
    //  timeout: 5000 // request timeout
});
service.interceptors.request.use(
    config => {
        // Do something before request is sent
        // config.headers["Token"] = getToken(); // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
        config.headers["Token"] = localStorage.getItem("commonToken");
        // config.headers["Content-Type"] = "application/json";
        return config;
    },
    error => {
        // Do something with request error
        console.log(error); // for debug
        Promise.reject(error);
    }
);
/** 拦截器中统一处理错误提示*/
service.interceptors.response.use(
    response => {
        // Do something with response data
        if (response.data.hasOwnProperty("success") && !response.data.success) {
            console.info(response.data.message);
        }
        return response;
    },
    error => {
        console.dir(error.toString()); // for debug
        return { data: { message: error.toString() } }; //返回一个空对象，主要是防止控制台报错
    }
);

/* 检查http码 */
function checkStatus(response) {
    if (
        response &&
        (response.data.code == "10009" || response.data.code == "10019")
    ) {
        global.exitLogin();
        return;
    }
    // 如果http状态码正常，则直接返回数据
    if (
        response &&
        (response.status === 200 ||
            response.status === 304 ||
            response.status === 400)
    ) {
        return response.data;
    }
    // 异常状态下，把错误信息返回去
    return {
        status: response.status,
        message: (response.data && response.data.message) || "操作过于频繁"
    };
}

function checkCode(res) {
    if (
        document.querySelector(".loading-box") &&
        document.querySelector(".loading-box").style
    ) {
        document.querySelector(".loading-box").style.display = "none";
    }
    // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
    if (res && (res.data.code == "10009" || res.data.code == "10019")) {
        global.exitLogin();
        return;
    }
    if (res.status === -404) {
        alert("-404");
    }
    // res.errorMsg != undefined 是否含有errorMsg
    if (res.hasOwnProperty("errorMsg")) {
        if (res.errorMsg == "session time out.") {} else {}
    }

    return res;
}

export default {
    post(url, data) {
        return service({
                method: "post",
                url,
                data
            })
            .then(response => {
                return checkStatus(response);
            })
            .catch(res => {
                return checkCode(res);
            });
    },
    put(url, data) {
        return service({
                method: "put",
                url,
                data,
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                return checkStatus(response);
            })
            .catch(res => {
                return checkCode(res);
            });
    },
    postType(url, data) {
        return service({
                method: "post",
                url,
                data,
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
            .then(response => {
                return checkStatus(response);
            })
            .catch(res => {
                return checkCode(res);
            });
    },
    postForm(url, data) {
        return service({
                method: "post",
                url,
                data,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            })
            .then(response => {
                return checkStatus(response);
            })
            .catch(res => {
                return checkCode(res);
            });
    },
    putForm(url, data) {
        return service({
                method: "put",
                url,
                data,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            })
            .then(response => {
                return checkStatus(response);
            })
            .catch(res => {
                return checkCode(res);
            });
    },
    delete(url, data) {
        return service({
                method: "delete",
                url,
                data,
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                return checkStatus(response);
            })
            .catch(res => {
                return checkCode(res);
            });
    },
    get(url, params) {
        return service({
                method: "get",
                url,
                params
            })
            .then(response => {
                return checkStatus(response);
            })
            .catch(res => {
                return checkCode(res);
            });
    },
    getExport(url, params) {
        return service({
                method: "get",
                url,
                params,
                responseType: "blob"
            })
            .then(response => {
                return checkStatus(response);
            })
            .catch(res => {
                return checkCode(res);
            });
    },
    _getExport(url, params) {
        return service({
                method: "post",
                url,
                params,
                responseType: "blob"
            })
            .then(response => {
                return checkStatus(response);
            })
            .catch(res => {
                return checkCode(res);
            });
    }
};


//////////////////
// WEBPACK FOOTER
// ./utils/http.js
// module id = null
// module chunks = 